const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';

export const login = credentials => ({
    type: 'INITIATED_LOGGED_IN',
    meta: {
        fetch: {
            url: `${API_URL}/api/users/authenticate`,
            settings: {
                method: 'POST',
                body: JSON.stringify({ email: credentials.email, password: credentials.password }),
            },
            actions: {
                success: 'LOGGED_IN_SUCCESS',
                error: 'LOGGED_IN_ERROR',
            },
        },
    },
});

export const resetPassword = email => ({
    type: 'INITIATED_PASSWORD_RESET',
    meta: {
        fetch: {
            url: `${API_URL}/api/users/pw-reset`,
            settings: {
                method: 'POST',
                body: JSON.stringify({ email }),
            },
            actions: {
                success: 'PASSWORD_RESET_SUCCESS',
                error: 'PASSWORD_RESET_ERROR',
            },
        },
    },
});

export const sendVerificationEmail = email => ({
    type: 'INITIATED_EMAIL_VERIFICATION',
    meta: {
        fetch: {
            url: `${API_URL}/api/users/verify-email`,
            settings: {
                method: 'POST',
                body: JSON.stringify({ email }),
            },
            actions: {
                success: 'EMAIL_VERIFICATION_SUCCESS',
                error: 'EMAIL_VERIFICATION_ERROR',
            },
        },
    },
});

export const updatePassword = (password, eid, iv) => ({
    type: 'INITIATED_PASSWORD_UPDATE',
    meta: {
        fetch: {
            url: `${API_URL}/api/users/update-pw`,
            settings: {
                method: 'POST',
                body: JSON.stringify({ password, eid, iv }),
            },
            actions: {
                success: 'PASSWORD_UPDATE_SUCCESS',
                error: 'PASSWORD_UPDATE_ERROR',
            },
        },
    },
});

export const createAccount = credentials => ({
    type: 'INITIATED_ACCOUNT_CREATION',
    meta: {
        fetch: {
            url: `${API_URL}/api/users`,
            settings: {
                method: 'POST',
                body: JSON.stringify({
                    email: credentials.email,
                    password: credentials.password,
                    firstName: credentials.firstName,
                    lastName: credentials.lastName,
                }),
            },
            actions: {
                success: 'ACCOUNT_CREATED_SUCCESS',
                error: 'ACCOUNT_CREATED_ERROR',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/actions/app.js